/**
 * Collection FAQ Accordion functionality
 * Handles smooth animations and accessibility features for FAQ accordions
 */

class CollectionFaqAccordion extends HTMLElement {
    constructor() {
      super();
      this.accordions = this.querySelectorAll('.collection-faq__accordion');
      this.init();
    }
  
    init() {
      this.accordions.forEach(accordion => {
        const summary = accordion.querySelector('summary');
        const content = accordion.querySelector('.accordion__content');
        
        // Set initial state
        if (!accordion.hasAttribute('open')) {
          content.style.maxHeight = '0px';
          content.style.overflow = 'hidden';
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
  
        // Add click event listener
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleAccordion(accordion, content);
        });
  
        // Add keyboard accessibility
        summary.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggleAccordion(accordion, content);
          }
        });
      });
    }
  
    toggleAccordion(accordion, content) {
      const isOpen = accordion.hasAttribute('open');
      
      if (isOpen) {
        // Close accordion
        this.closeAccordion(accordion, content);
      } else {
        // Close other accordions if you want only one open at a time
        // this.closeAllAccordions();
        
        // Open accordion
        this.openAccordion(accordion, content);
      }
    }
  
    openAccordion(accordion, content) {
      accordion.setAttribute('open', '');
      
      // Animate opening
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.overflow = 'hidden';
      
      // Clean up after animation
      setTimeout(() => {
        content.style.maxHeight = 'none';
        content.style.overflow = 'visible';
      }, 300);
  
      // Dispatch custom event
      accordion.dispatchEvent(new CustomEvent('accordion:opened', {
        bubbles: true,
        detail: { accordion }
      }));
    }
  
    closeAccordion(accordion, content) {
      // Set explicit height before animating
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.overflow = 'hidden';
      
      // Force reflow
      content.offsetHeight;
      
      // Animate closing
      content.style.maxHeight = '0px';
      
      // Remove open attribute after animation
      setTimeout(() => {
        accordion.removeAttribute('open');
      }, 300);
  
      // Dispatch custom event
      accordion.dispatchEvent(new CustomEvent('accordion:closed', {
        bubbles: true,
        detail: { accordion }
      }));
    }
  
    closeAllAccordions() {
      this.accordions.forEach(accordion => {
        const content = accordion.querySelector('.accordion__content');
        if (accordion.hasAttribute('open')) {
          this.closeAccordion(accordion, content);
        }
      });
    }
  }
  
  // Initialize when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      customElements.define('collection-faq-accordion', CollectionFaqAccordion);
    });
  } else {
    customElements.define('collection-faq-accordion', CollectionFaqAccordion);
  }
  
  // Auto-initialize existing accordions
  document.querySelectorAll('.collection-faq-accordion').forEach(accordion => {
    if (!accordion.classList.contains('initialized')) {
      new CollectionFaqAccordion.call(accordion);
      accordion.classList.add('initialized');
    }
  });